export default __webpack_public_path__ + "static/media/User-management-information.cb866538.svg";